import React from 'react'
import { Box, Heading } from '@chakra-ui/react'
import LatestTracks from '../components/SearchResults/LatestTracks'
import { useColorModeValue } from '@chakra-ui/react'

export const HomePage = () => {
  const bg = useColorModeValue( "brand.secondary", "brand.lighterBlack" )
  const color = useColorModeValue( "brand.textLink", "brand.textLight" )

  return (
    <Box
      mt={9}
      px={{ 'base': 0, 'md': 1, 'lg': 2, 'xl': 3 }}
      position="relative">
      <Box my={2}>
        <Heading
          lineHeight={1}
          fontSize="5xl"
          w="fit-content"
          fontFamily="regular"
          fontWeight="bold">
          Soundify
        </Heading>
        <Heading
          w="fit-content"
          fontSize="xl"
          fontFamily="regular"
          fontWeight="light">
          theNextBigThing™ Music
        </Heading>
      </Box>
      <LatestTracks />
    </Box>
  )
}